import * as privateEnv from '~config/privateEnv';
import * as publicEnv from '~config/publicEnv';
import { IS_SSR } from '~constants/common';
import { MemberResponse } from '~models/MemberDto';
import { HttpClient, RequestParams } from '~utils/https/HttpClientFetch';

/**
 * @title Member API
 * @baseUrl https://api3.myrealtrip.com/member/v1/members
 * @apiDoc https://api-member.stage-myrealtrip.net/swagger-ui.html#/member-controller
 *
 */
class MemberApi<SecurityDataType> extends HttpClient<SecurityDataType> {
  v1 = {
    /**
     * @description 유저 정보를 조회합니다.
     *
     * @tags front-member-controller
     * @name members
     * @summary 유저 정보 조회 API
     * @request GET:/v1/members
     */
    members: (params: RequestParams = {}) =>
      this.request<MemberResponse>({
        path: `/v1/members`,
        method: 'GET',
        format: 'json',
        ...params,
      }),
    /**
     * @description 여행자(member) 정보 삭제
     *
     * @tags Member > Traveler
     * @name DeleteMember
     * @request DELETE: /traveler-infos/{userId}
     */
    deleteMember: (userId: string) =>
      this.request({
        path: `/traveler-infos/${userId}`,
        method: 'DELETE',
      }),
  };
}

const memberApi = new MemberApi({
  baseURL: IS_SSR ? privateEnv.MEMBER_API_ENDPOINT : publicEnv.MEMBER_API_ENDPOINT,
  secureWorker(securityData) {
    return {
      headers: {
        Authorization: `Bearer ${securityData}`,
      },
    };
  },
  secure: false,
});

export { memberApi };
